import Glide from '@glidejs/glide';

export default class CardList {
    static exec() {
        const els = document.querySelectorAll('[data-component="card-list:glide"]');
        els.forEach(function (el) {
            new CardList(el, true);
        })
    }

    el;
    playButton;
    pauseButton;
    glide;
    glideOptions = {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      autoplay: false,
      hoverpause: false,
      animationDuration: 1600,
      peek: {
          before: 0,
          after: 0,
      },
      breakpoints: {
        768: {
          perView: 1,
          peek: {
            before: 0,
            after: 80,
          },
        },
      },
    };

    constructor(element, carousel= false) {
        let self = this;
        this.el = element

        let options = JSON.parse(element.getAttribute('data-glide-options'));
        this.glideOptions = Object.assign(this.glideOptions, options);
        this.playButton = this.el.querySelectorAll('[data-el="play"]');
        this.pauseButton = this.el.querySelectorAll('[data-el="pause"]');
        this.glide = new Glide(element, this.glideOptions).mount();
        this.playButton.forEach(function(el) {
           el.addEventListener('click', function() {
                self.play();
           });
        });
        this.pauseButton.forEach(function(el) {
            el.addEventListener('click', function() {
                self.pause();
            });
        });
    }

    play() {
        this.glide.play();
        this.playButton.forEach(function(el) {
            el.classList.add('!hidden');
        });
        this.pauseButton.forEach(function(el) {
            el.classList.remove('!hidden');
        });
    }

    pause() {
        this.glide.pause();
        this.playButton.forEach(function(el) {
            el.classList.remove('!hidden');
        });
        this.pauseButton.forEach(function(el) {
            el.classList.add('!hidden');
        });
    }
}
